/* eslint-disable react-refresh/only-export-components -- activation registry pattern: components are referenced via exported config object */
import { MessageSquare } from 'lucide-react';

import type { RenderedMessage, WorkflowActionConfigSafe } from '../../types';
import { Badge } from '../ui/badge';
import type { IntegrationActivation } from './types';

function SlackPreviewMessage({ message }: { message: RenderedMessage }): React.ReactElement | null {
  if (message.type !== 'slack_webhook') return null;
  return (
    <div className="rounded-md border-l-4 border-purple-400 bg-muted/50 px-3 py-2 text-sm">{message.slackText}</div>
  );
}

function SlackConfigSummary({ config }: { config: WorkflowActionConfigSafe }): React.ReactElement {
  return (
    <div className="space-y-2 text-sm">
      <div className="flex items-center gap-2">
        <MessageSquare size={14} className="text-muted-foreground" />
        <span className="font-medium">Slack Webhook</span>
        <Badge variant="outline" className="text-[0.625rem]">
          {config.mode === 'per_row' ? 'Customer-facing' : 'Internal'}
        </Badge>
      </div>
      {config.messageTemplate && (
        <div>
          <p className="mb-1 text-xs text-muted-foreground">Message Template</p>
          <pre className="overflow-x-auto rounded-md bg-muted p-2 text-xs">{config.messageTemplate}</pre>
        </div>
      )}
    </div>
  );
}

export const slackWebhookActivation: IntegrationActivation = {
  type: 'slack_webhook',
  label: 'Slack Webhook',
  icon: MessageSquare,
  PreviewMessage: SlackPreviewMessage,
  ConfigSummary: SlackConfigSummary,
};
